import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  max-width: 100vw;
  min-width: 100%;
  background: ${({ theme }) => theme.colors.secondary};
  color: ${({ theme }) => theme.colors.background_white};
  font-family: 'Roboto', sans-serif;
  overflow-x: hidden;

  @media (max-width: 850px) {
    flex-direction: column;
  }

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

export const HeroSection = styled.section`
  display: flex;
  width: 90%;
  justify-content: space-between;
  align-items: center;
  padding: 4rem 8rem;
  min-height: 40rem;
  background: ${({ theme }) => theme.colors.secondary};

  .content {
    max-width: 45%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    h1 {
      font-size: 3.5rem;
      font-weight: 700;
      line-height: 1.4;
      margin-bottom: 3rem;
      color: ${({ theme }) => theme.colors.background_white};
    }

    button {
      border-radius: 5rem;
      align-self: flex-start;
      width: 80%;
      height: 6rem;
    }
  }

  .hero-image {
    max-width: 40%;
    height: auto;
  }

  @media (max-width: 850px) {
    flex-direction: column;
    padding: 3rem 2rem;
    .content {
      max-width: 100%;
      text-align: center;
      align-items: center;

      h1 {
        font-size: 2.5rem;
      }
      button {
        width: 100%;
        border-radius: 5rem;
        align-items: center;
        text-align: center;
      }
    }
    .hero-image {
      max-width: 100%;
      margin-top: 3rem;
    }
  }

  @media (max-width: 600px) {
    padding: 2rem 1rem;
    .content {
      h1 {
        font-size: 2rem;
      }
      button {
        height: 5rem;
      }
    }
    .hero-image {
      max-width: 90%;
    }
  }
`;

export const FindLawyerSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4rem 10rem;
  background: ${({ theme }) => theme.colors.secondary};

  h2 {
    font-size: 2.4rem;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.background_white};
    text-align: flex-start;
    margin-bottom: 4rem;
  }

  .find-correspondent {
    width: 85%;
  }

  @media (max-width: 850px) {
    padding: 3rem 2rem;
    h2 {
      text-align: center;
      font-size: 2rem;
    }
    .find-correspondent {
      width: 95%;
      max-width: 95%;
    }
  }

  @media (max-width: 600px) {
    padding: 2rem 1rem;
    h2 {
      font-size: 1.8rem;
    }
  }
`;

export const FeaturesSection = styled.section`
  padding: 8rem 15rem;
  text-align: center;
  background: ${({ theme }) => theme.colors.secondary};

  h2 {
    font-size: 3rem;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.tertiary_500};
    margin-bottom: 3rem;
  }

  .icon {
    background: ${({ theme }) => theme.colors.tertiary_500};
    color: ${({ theme }) => theme.colors.background_white};
    border-radius: 50%;
    width: 10rem;
    height: 10rem;
    margin: 0 auto 2.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 4rem;
  }

  h3 {
    font-size: 1.8rem;
    font-weight: 700;
    margin-bottom: 2.5rem;
    color: ${({ theme }) => theme.colors.background_white};
  }

  .features {
    display: flex;
    justify-content: space-around;
    gap: 3rem;

    .feature-card {
      background: ${({ theme }) => theme.colors.secondary};
      border: 1px solid ${({ theme }) => theme.colors.background_white};
      border-radius: 1.5rem;
      padding: 3rem;
      text-align: center;

      p {
        font-size: 1.4rem;
        font-weight: 400;
        color: ${({ theme }) => theme.colors.background_white};
      }
    }
  }

  @media (max-width: 850px) {
    width: 100%;
    padding: 4rem 2rem;
    .features {
      display: flex;
      flex-direction: column;
      max-width: 85%;
      .feature-card {
        padding: 2rem;
        .icon {
          width: 8rem;
          height: 8rem;
          font-size: 3rem;
        }
        h3 {
          font-size: 1.5rem;
        }
        p {
          font-size: 1.2rem;
        }
      }
    }
  }

  @media (max-width: 600px) {
    display: flex;
    flex-direction: column;
    padding: 0;
    .features {
      display: flex;
      margin: auto;
      .feature-card {
        padding: 1.5rem;
        .icon {
          width: 6rem;
          height: 6rem;
          font-size: 2.5rem;
        }
        h3 {
          font-size: 1.3rem;
        }
        p {
          font-size: 1rem;
        }
      }
    }
  }
`;

export const FreeExperienceSection = styled.section`
  background: ${({ theme }) => theme.colors.secondary};
  padding: 7rem 15rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: ${({ theme }) => theme.colors.background_white};
  position: relative;

  .content-container {
    max-width: 50%;
    align-self: flex-start;
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 1;
  }

  .path-dotted {
    position: absolute;
    top: 5;
    right: 0;
    width: 35%;
    height: 85%;
    object-fit: cover;
    opacity: 0.8;
    z-index: 0;
  }

  h2 {
    width: 50%;
    font-size: 3.5rem;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.tertiary_500};
    margin-bottom: 3rem;
    text-align: flex-start;
    z-index: 1;
  }

  ul {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    list-style: none;
    margin-bottom: 3rem;
    z-index: 1;
    li {
      display: flex;
      align-items: center;
      font-size: 2rem;
      padding-left: 2.5rem;
      position: relative;
      &:before {
        content: '✅';
        color: #00cc00;
        position: absolute;
        left: 0;
        font-size: 1.9rem;
      }
    }
  }

  button {
    padding: 2rem 2rem;
    border: none;
    border-radius: 5rem;
    cursor: pointer;
    font-size: 1.2rem;
    font-weight: 600;
    z-index: 1;
    &:hover {
      filter: brightness(0.9);
    }
  }

  @media (max-width: 850px) {
    padding: 4rem 2rem;
    text-align: center;
    .content-container {
      max-width: 100%;
    }
    h2 {
      width: 100%;
      font-size: 2.5rem;
      text-align: center;
    }
    ul li {
      font-size: 1.5rem;
    }
    .path-dotted {
      display: none;
    }
  }

  @media (max-width: 600px) {
    padding: 3rem 1rem;
    h2 {
      font-size: 2rem;
    }
    ul li {
      font-size: 1.2rem;
    }
    button {
      width: 100%;
      font-size: 1rem;
    }
  }
`;

export const TestimonialsSection = styled.section`
  padding: 4rem 8rem;
  text-align: center;

  h2 {
    font-size: 3rem;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.tertiary_500};
    margin-bottom: 3rem;
  }

  .testimonials {
    display: flex;
    justify-content: space-around;
    gap: 3rem;

    .testimonial-card {
      background: rgba(255, 255, 255, 0.05);
      color: ${({ theme }) => theme.colors.background_white};
      border: 1px solid ${({ theme }) => theme.colors.background_white};
      border-radius: 1.5rem;
      padding: 8rem 3rem;
      width: 30%;
      text-align: left;

      p {
        font-size: 2rem;
        font-weight: 400;
        margin-bottom: 1.5rem;
        padding: 1rem;
      }

      .author {
        font-size: 1.8rem;
        font-weight: 600;
      }
    }
  }

  @media (max-width: 850px) {
    padding: 3rem 2rem;
    .testimonials {
      flex-direction: column;
      align-items: center;
      .testimonial-card {
        display: flex;
        flex-direction: column;
        width: 85%;
        padding: 2rem;
        p {
          font-size: 1.5rem;
        }
        .author {
          font-size: 1.2rem;
        }
      }
    }
  }

  @media (max-width: 600px) {
    padding: 2rem 1rem;
    .testimonials {
      .testimonial-card {
        padding: 1.5rem;
        p {
          font-size: 1.2rem;
        }
        .author {
          font-size: 1rem;
        }
      }
    }
  }
`;

export const AboutSection = styled.section`
  display: flex;
  padding: 6rem 8rem;
  align-items: center;
  gap: 8rem;

  .about-image {
    max-width: 40%;
    height: auto;
    border-radius: 0 5rem 0 0;
    object-fit: cover;
  }

  .content {
    background-color: ${({ theme }) => theme.colors.secondary};
    border-radius: 2rem;
    padding: 2.5rem;
    color: ${({ theme }) => theme.colors.background_white};

    h2 {
      font-family: 'Roboto', sans-serif;
      font-size: 3.5rem;
      font-weight: 700;
      color: ${({ theme }) => theme.colors.tertiary_500};
      margin-bottom: 2rem;
      text-align: center;
    }

    p {
      font-family: 'Roboto', sans-serif;
      font-size: 1.4rem;
      font-weight: 400;
      margin-bottom: 1.5rem;
      text-align: center;
      line-height: 1.8;
    }

    p:last-child {
      margin-bottom: 0;
    }
  }

  @media (max-width: 850px) {
    flex-direction: column;
    padding: 3rem 2rem;
    gap: 4rem;
    .about-image {
      max-width: 100%;
      border-radius: 0 2rem 0 0;
    }
    .content {
      padding: 1.5rem;
      text-align: center;
      h2 {
        font-size: 2rem;
      }
      p {
        font-size: 1rem;
      }
    }
  }

  @media (max-width: 600px) {
    padding: 2rem 1rem;
    gap: 2rem;
    .content {
      padding: 1rem;
      h2 {
        font-size: 1.8rem;
      }
      p {
        font-size: 0.9rem;
      }
    }
  }
`;

export const FAQSection = styled.section`
  padding: 4rem 8rem;

  h2 {
    font-size: 3rem;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.tertiary_500};
    margin-bottom: 3rem;
    text-align: center;
  }

  .faq-item {
    border: 1px solid ${({ theme }) => theme.colors.background_white};
    border-radius: 1.5rem;
    padding: 2rem;
    margin-bottom: 1.5rem;

    h3 {
      font-size: 1.3rem;
      font-weight: 700;
      margin-bottom: 1rem;
    }

    p {
      font-size: 1.1rem;
      font-weight: 400;
    }
  }

  @media (max-width: 850px) {
    padding: 3rem 2rem;
    h2 {
      font-size: 2.5rem;
    }
    .faq-item {
      padding: 1.5rem;
      h3 {
        font-size: 1.2rem;
      }
      p {
        font-size: 1rem;
      }
    }
  }

  @media (max-width: 600px) {
    padding: 2rem 1rem;
    h2 {
      font-size: 2rem;
    }
    .faq-item {
      padding: 1rem;
      h3 {
        font-size: 1rem;
      }
      p {
        font-size: 0.9rem;
      }
    }
  }
`;

export const Footer = styled.footer`
  display: flex;
  justify-content: space-between;
  padding: 3rem 8rem;
  background: linear-gradient(
    to right,
    ${({ theme }) => theme.colors.secondary},
    ${({ theme }) => theme.colors.tertiary_500}
  );

  .contact {
    h3 {
      font-size: 2rem;
      font-weight: 700;
      color: ${({ theme }) => theme.colors.tertiary_500};
      margin-bottom: 1.5rem;
    }

    p {
      font-size: 1.1rem;
      margin-bottom: 1rem;
      strong {
        color: ${({ theme }) => theme.colors.tertiary_500};
      }
    }

    .social-icons {
      display: flex;
      gap: 1.5rem;
      svg {
        fill: ${({ theme }) => theme.colors.background_white};
        width: 2rem;
        height: 2rem;
      }
    }
  }

  .logo {
    img {
      max-width: 18rem;
      height: auto;
    }
  }

  @media (max-width: 850px) {
    padding: 2rem;
    flex-direction: column;
    align-items: center;
    .contact {
      text-align: center;
    }
    .logo {
      margin-top: 2rem;
    }
  }

  @media (max-width: 600px) {
    padding: 1.5rem;
    .contact {
      h3 {
        font-size: 1.5rem;
      }
      p {
        font-size: 0.9rem;
      }
      .social-icons svg {
        width: 1.5rem;
        height: 1.5rem;
      }
    }
    .logo img {
      max-width: 12rem;
    }
  }
`;

export const FindCorrespondentContainer = styled.div`
  background: ${({ theme }) => theme.colors.background};
  border: 1px solid ${({ theme }) => theme.colors.background_white};
  border-radius: 1.5rem;
  padding: 3rem;
  width: 90%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  select {
    background: transparent;
    border: none;
    border-bottom: 1px solid ${({ theme }) => theme.colors.background_white};
    color: ${({ theme }) => theme.colors.background_white};
    padding: 0.5rem;
    font-size: 1rem;
  }

  h1 {
    font-size: 1.5rem;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.background_white};
    margin: 0.5rem 0;
  }

  @media (max-width: 850px) {
    padding: 1.5rem;
    flex-direction: column;
    gap: 1rem;
    select {
      font-size: 0.9rem;
    }
    h1 {
      font-size: 1.2rem;
    }
  }

  @media (max-width: 600px) {
    padding: 1rem;
    select {
      font-size: 0.8rem;
    }
    h1 {
      font-size: 1rem;
    }
  }
`;
